import { Grid } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import GroupHeader from './components/GroupHeader';
import { IGroup } from 'parent-portal/group/models';
import TabHandler from './components/TabHandler';
import { getMyGroups, getAllGroups } from '../../../group/shared/api';
import { isLoggedIn } from 'api/UserApi';
import { Paper, Text, Colors } from 'library';

export default function GroupListingPage() {
    const [myGroups, setMyGroups] = useState<IGroup[]>([]);
    const [exploreGroups, setExploreGroups] = useState<IGroup[]>([]);
    const [loaded, setLoaded] = useState(false);
    const groups: IGroup[][] = [myGroups, exploreGroups];

    useEffect(() => {
        if (isLoggedIn()) {
            Promise.all([getMyGroups(setMyGroups), getAllGroups(setExploreGroups)]).then(() => setLoaded(true));
        } else {
            Promise.all([getAllGroups(setExploreGroups)]).then(() => setLoaded(true));
        }
    }, []);

    return (
        <>
            <Paper
                style={{
                    marginTop: !isLoggedIn() ? 40 : 0,
                    justifyContent: 'center',
                    maxWidth: '100vh',
                }}
            >
                <Grid container item xs={12}>
                    <Grid container item>
                        <GroupHeader />
                    </Grid>
                    {isLoggedIn() ? (
                        <>
                            <Text variant="h1" color={Colors.turquoise} textStyle={{ paddingTop: 20 }}>
                                My Groups
                            </Text>
                            <Grid container direction="row">
                                <TabHandler loaded={loaded} groups={groups[0]} />
                            </Grid>
                        </>
                    ) : null}
                    <Text variant="h1" color={Colors.turquoise} textStyle={{ paddingTop: 20 }}>
                        Explore Groups
                    </Text>
                    <Grid container item>
                        <TabHandler loaded={loaded} groups={groups[1]} />
                    </Grid>
                </Grid>
            </Paper>
        </>
    );
}
